import React from "react"
import FormattedMessage from "@irati/utils/lang"
import {H2} from "@irati/ui/src/Headings"
import {Label2} from "@irati/ui/src/Labels"
import RequestNewLinkButton from "../../components/UserOnboarding/RequestNewLinkButton"

/** @description: This will be the V2 onboarding container once v4 goes live */
const RequestNewLink: React.FC = () => {
  return (
    <div>
      <H2 small>
        <FormattedMessage id="onboarding.old.header" />
      </H2>
      <Label2>
        <RequestNewLinkButton body="onboarding.old.body" />
      </Label2>
    </div>
  )
}

export default RequestNewLink
